import {TStimLocation} from "../../protocols/types/protocol";
import {IStimDevice} from "./StimDevice";

export enum TStimPolarity {
    Anodic = "anodic",
    Cathodic = "acthodic"
}

export enum TStimShape {
    MONOPHASIC = "monophasic",
    BIPHASIC = "biphasic",
    BIPHASIC_DEADZONE = "biphasicwithdeadzone",
    TRIPHASIC = "triphasic"
}

/** A Stimulation configuration. Defines a pre-stim interval,
 * post-stim interval,  and a stimulation train to execute
 */
export type TStimConfig = {
    stim_shape: TStimShape;
    polarity: TStimPolarity;
    num_pulses: number;
    train_period_ms: number;
    refactory_period_sec?: number;
    first_phase_duration_us: number;
    second_phase_duration_us: number;
    deadzone_duration_us: number;
    third_phase_duration_us: number;
    first_phase_amplitude_uA: number;
    second_phase_amplitude_uA: number;
    channels: Array<string>;
    differential_stim_gnd_channels: [number];
}

export type TStimMetadata = {
    stimLocation?: TStimLocation
    /**
     * This is the time period that trains repeat for.
     */
    treatmentDurationSec?: number

    stimDevice?: IStimDevice
    config?: TStimConfig
    program_name?: string
}

/**
 * Used to create a StimConfiguration.
 * @params TStimConfig configuration with defaults for rarely used values that
 * must be set to 0 when not used
 *
 */
export const createStimConfig = ({
                                     second_phase_duration_us = 0,
                                     deadzone_duration_us = 0,
                                     third_phase_duration_us = 0,
                                     second_phase_amplitude_uA = 0,
                                     ...others
                                 }: TStimConfig): TStimConfig => {
    return {
        second_phase_duration_us,
        deadzone_duration_us,
        third_phase_duration_us,
        second_phase_amplitude_uA,
        ...others
    }
}

